import { ProductCell } from 'components/Table/MRTTable/CustomCell';
import {
  SExpiryItem,
  SLowStockItem,
  SStaffMetrics,
  STopSellingItems,
} from 'pages/AIDashboard/types';
import { formattedRupee } from 'utils/util';

export const BAR_VIEW_TYPE = (): { [key: string]: string } => ({
  ['Footfall & Sales']: 'Footfall & Sales',
  ['Days Of Week']: 'Days Of Week',
});

export const PIE_VIEW_TYPE = (): { [key: string]: string } => ({
  ['Age Group']: 'Age Group',
  ['Category']: 'Category',
});

export const UNIT_TYPE = (): { [key: string]: string } => ({
  Number: 'Number',
  Percentage: 'Percentage',
});

export const daysOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const StaffMetricsColumns = [
  {
    header: 'S.No',
    accessorKey: 'index',
  },
  { header: 'Staff Name', accessorKey: 'name' },
  { header: 'Sales', accessorKey: 'sales' },
  {
    header: 'Invoice Value',
    accessorKey: 'invoiceValue',
    accessorFn: (value: unknown) => formattedRupee((value as SStaffMetrics).invoiceValue ?? value),
  },
];

export const TopSKUColumns = [
  {
    header: 'S.No',
    accessorKey: 'index',
  },
  {
    header: 'SKU Name',
    accessorKey: 'name',
    Cell: (row: unknown) => {
      const skuId = (row as STopSellingItems)?.id;
      return (
        <ProductCell
          href={`/inventory/${skuId}?tab=0`}
          value={(row as STopSellingItems)?.name as string}
        />
      );
    },
  },
  { header: 'Sale Qty', accessorKey: 'saleQty' },
];

export const ExpiryItemColumns = [
  {
    header: 'S.No',
    accessorKey: 'index',
  },
  {
    header: 'Sku Name',
    accessorKey: 'name',
    Cell: (row: unknown) => {
      const skuId = (row as SExpiryItem)?.id;
      return (
        <ProductCell
          href={`/inventory/${skuId}?tab=0`}
          value={(row as SExpiryItem)?.name as string}
        />
      );
    },
  },
  { header: 'Batch', accessorKey: 'batchNo' },
  { header: 'Stock', accessorKey: 'stock' },
  { header: 'Expiry', accessorKey: 'expiry' },
];

export const LowStockColumns = [
  {
    header: 'S.No',
    accessorKey: 'index',
  },
  {
    header: 'Sku Name',
    accessorKey: 'name',
    Cell: (row: unknown) => {
      const skuId = (row as SLowStockItem)?.id;
      return (
        <ProductCell
          href={`/inventory/${skuId}?tab=0`}
          value={(row as SLowStockItem)?.name as string}
        />
      );
    },
  },
  { header: 'Threshold', accessorKey: 'threshold' },
  { header: 'Max Threshold', accessorKey: 'maxThreshold' },
  { header: 'Stock', accessorKey: 'stock' },
];

export const INITIAL_HEADER_DATA = {
  liveFootfallCount: 0,
  demographicCount: '',
  salesValue: 0,
  salesMargin: 0,
  avgOrderValue: 0,
  skuCount: 0,
  itemCount: 0,
  outOfStockCount: 0,
};

export const INITIAL_PIE_DATA = {
  labels: [],
  datasets: [],
};

export const INITIAL_MODAL_DATA = {
  title: '',
  columns: [],
  data: [],
};

export const LowStockURL = '/inventory?stock=Low+Stock';
export const ExpiryItemsURL = '/inventory?expiry=This+Month';
export const ExpiredItemsURL = '/inventory?expiry=Expired';
